import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faArrowUp, faArrowDown, faSync, faEye, faCheck, faTimes, faSearch } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import 'jspdf-autotable';
import baseURL from '../../url';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import './PagosData.css';

export default function PagosData() {
    const [pagos, setPagos] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [pagoSeleccionado, setPagoSeleccionado] = useState(null);
    const [accion, setAccion] = useState('');
    const [motivoRechazo, setMotivoRechazo] = useState('');
    const [selectedSection, setSelectedSection] = useState('texto');
    const [filtroId, setFiltroId] = useState('');
    const [filtroEstado, setFiltroEstado] = useState('');
    const [filtroNombre, setFiltroNombre] = useState('');
    const [filtroNumero, setFiltroNumero] = useState('');
    const [ordenInvertido, setOrdenInvertido] = useState(false);
    const [rifas, setRifas] = useState([]);
    const [visibleCount, setVisibleCount] = useState(20);
    const [imagenModal, setImagenModal] = useState({ visible: false, src: '' });

    const handleShowMore = () => {
        setVisibleCount(prevCount => prevCount + 20);
    };

    const handleImageClick = (imagenBase64) => {
        setImagenModal({
            visible: true,
            src: `data:image/jpeg;base64,${imagenBase64}`
        });
    };

    const closeImageModal = () => {
        setImagenModal({ visible: false, src: '' });
    };

    useEffect(() => {
        cargarPagos();
        cargarRifas();
    }, []);

    const cargarPagos = () => {

        fetch(`${baseURL}/pagosGet.php`, {
            method: 'GET',
        })
            .then(response => {

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {

                setPagos(data || []);
            })
            .catch(error => {

                // Mostrar datos de prueba en caso de error
                const pagosSimulados = [
                    {
                        idPago: 1,
                        idRifa: 1,
                        numeros: "0001,0002",
                        nombre: "Juan Pérez",
                        telefono: "0412-123-4567",
                        email: "juan@email.com",
                        direccion: "Caracas",
                        metodo_pago: "mobile",
                        referencia: "REF123",
                        imagen_comprobante: null,
                        estado: "pendiente",
                        motivo_rechazo: null,
                        aprobado_por: null,
                        fecha_aprobacion: null,
                        createdAt: "2025-09-22 20:31:49",
                        updatedAt: "2025-09-22 20:31:49",
                        rifa_nombre: "Rifa Test",
                        precio: "50"
                    },
                    {
                        idPago: 2,
                        idRifa: 1,
                        numeros: "0003,0004",
                        nombre: "María García",
                        telefono: "0414-987-6543",
                        email: "maria@email.com",
                        direccion: "Valencia",
                        metodo_pago: "bank",
                        referencia: "REF456",
                        imagen_comprobante: null,
                        estado: "aprobado",
                        motivo_rechazo: null,
                        aprobado_por: "Admin",
                        fecha_aprobacion: "2025-09-22 21:00:00",
                        createdAt: "2025-09-22 20:45:30",
                        updatedAt: "2025-09-22 21:00:00",
                        rifa_nombre: "Rifa Test",
                        precio: "50"
                    }
                ];
                setPagos(pagosSimulados);
            });
    };

    const cargarRifas = () => {
        fetch(`${baseURL}/rifaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setRifas(data.rifas || []);
            })
            .catch(error => {});
    };

    const filtrados = pagos.filter(pago => {
        const cumpleId = !filtroId || pago.idPago.toString().includes(filtroId);
        const cumpleEstado = !filtroEstado || pago.estado === filtroEstado;
        const cumpleNombre = !filtroNombre || pago.nombre.toLowerCase().includes(filtroNombre.toLowerCase());
        const cumpleNumero = !filtroNumero || pago.numeros.includes(filtroNumero);
        return cumpleId && cumpleEstado && cumpleNombre && cumpleNumero;
    });

    const handleAprobar = (pago) => {
        setPagoSeleccionado(pago);
        setAccion('aprobar');
        setModalVisible(true);
    };

    const handleRechazar = (pago) => {
        setPagoSeleccionado(pago);
        setAccion('rechazar');
        setMotivoRechazo('');
        setModalVisible(true);
    };

    const confirmarAccion = async () => {
        if (!pagoSeleccionado) return;

        try {
            let url, body;
            
            if (accion === 'aprobar') {
                url = `${baseURL}/pagoAprobar.php`;
                body = {
                    idPago: pagoSeleccionado.idPago,
                    aprobadoPor: 'Administrador'
                };
            } else {
                url = `${baseURL}/pagoRechazar.php`;
                body = {
                    idPago: pagoSeleccionado.idPago,
                    motivoRechazo: motivoRechazo || 'Sin motivo especificado',
                    aprobadoPor: 'Administrador'
                };
            }

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body)
            });

            const result = await response.json();
            
            if (result.error) {
                toast.error('Error: ' + result.error);
            } else {
                toast.success(result.mensaje);
                setModalVisible(false);
                cargarPagos();
            }
        } catch (error) {

            toast.error('Error al procesar la acción: ' + error.message);
        }
    };

    const getMetodoPagoTexto = (metodo) => {
        switch (metodo) {
            case 'mobile': return 'Pago Móvil';
            case 'zelle': return 'Zelle';
            case 'binance': return 'Binance';
            default: return metodo;
        }
    };

    const getEstadoColor = (estado) => {
        switch (estado) {
            case 'pendiente': return '#DAA520';
            case 'aprobado': return '#008000';
            case 'rechazado': return '#FF0000';
            default: return '#666';
        }
    };

    const getEstadoTexto = (estado) => {
        switch (estado) {
            case 'pendiente': return 'Pendiente';
            case 'aprobado': return 'Aprobado';
            case 'rechazado': return 'Rechazado';
            default: return estado;
        }
    };

    const exportToExcel = () => {
        const data = filtrados.map(pago => ({
            ID: pago.idPago,
            Rifa: pago.rifa_nombre || 'N/A',
            Números: pago.numeros,
            Cliente: pago.nombre,
            Teléfono: pago.telefono,
            Email: pago.email,
            'Método Pago': getMetodoPagoTexto(pago.metodo_pago),
            Referencia: pago.referencia || 'N/A',
            Estado: getEstadoTexto(pago.estado),
            Fecha: new Date(pago.createdAt).toLocaleDateString(),
            'Aprobado Por': pago.aprobado_por || 'N/A',
            'Fecha Aprobación': pago.fecha_aprobacion ? new Date(pago.fecha_aprobacion).toLocaleDateString() : 'N/A'
        }));

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Pagos');
        XLSX.writeFile(wb, 'pagos.xlsx');
    };

    const exportToPDF = () => {
        const columns = [
            { title: 'ID', dataKey: 'idPago' },
            { title: 'Rifa', dataKey: 'rifa_nombre' },
            { title: 'Números', dataKey: 'numeros' },
            { title: 'Cliente', dataKey: 'nombre' },
            { title: 'Teléfono', dataKey: 'telefono' },
            { title: 'Email', dataKey: 'email' },
            { title: 'Estado', dataKey: 'estado' },
            { title: 'Fecha', dataKey: 'createdAt' }
        ];

        const data = filtrados.map(pago => ({
            idPago: pago.idPago,
            rifa_nombre: pago.rifa_nombre || 'N/A',
            numeros: pago.numeros,
            nombre: pago.nombre,
            telefono: pago.telefono,
            email: pago.email,
            estado: getEstadoTexto(pago.estado),
            createdAt: new Date(pago.createdAt).toLocaleDateString()
        }));

        const doc = new jsPDF();
        doc.autoTable({
            columns: columns,
            body: data,
            startY: 20,
            styles: { fontSize: 8 },
            headStyles: { fillColor: [41, 128, 185] }
        });
        doc.save('pagos.pdf');
    };

    return (
        <div className="pagosData">
            <div className="headerPagos">
                <h2>Gestión de Pagos</h2>
                <div className="buttonsHeader">
                    <button onClick={cargarPagos} className="btnRefresh">
                        <FontAwesomeIcon icon={faSync} />
                        Actualizar
                    </button>
                    <button onClick={exportToExcel} className="btnExcel">
                        <FontAwesomeIcon icon={faArrowDown} />
                        Excel
                    </button>
                    <button onClick={exportToPDF} className="btnPdf">
                        <FontAwesomeIcon icon={faArrowUp} />
                        PDF
                    </button>
                </div>
            </div>

            <div className="filtrosContainer">
                <div className="filtrosTitle">
                    <FontAwesomeIcon icon={faSearch} />
                    Filtros de Búsqueda
                </div>
                <div className="filtrosGrid">
                    <div className="filtroGroup">
                        <label className="filtroLabel">ID del Pago</label>
                        <input 
                            type="text" 
                            className="filtroInput"
                            value={filtroId} 
                            onChange={(e) => setFiltroId(e.target.value)} 
                            placeholder="Ej: 1, 2, 3..." 
                        />
                    </div>
                    <div className="filtroGroup">
                        <label className="filtroLabel">Nombre del Cliente</label>
                        <input 
                            type="text" 
                            className="filtroInput"
                            value={filtroNombre} 
                            onChange={(e) => setFiltroNombre(e.target.value)} 
                            placeholder="Ej: Juan Pérez" 
                        />
                    </div>
                    <div className="filtroGroup">
                        <label className="filtroLabel">Números de Rifa</label>
                        <input 
                            type="text" 
                            className="filtroInput"
                            value={filtroNumero} 
                            onChange={(e) => setFiltroNumero(e.target.value)} 
                            placeholder="Ej: 0001, 0002" 
                        />
                    </div>
                    <div className="filtroGroup">
                        <label className="filtroLabel">Estado del Pago</label>
                        <select 
                            className="filtroSelect"
                            value={filtroEstado} 
                            onChange={(e) => setFiltroEstado(e.target.value)}
                        >
                            <option value="">Todos los estados</option>
                            <option value="pendiente">Pendiente</option>
                            <option value="aprobado">Aprobado</option>
                            <option value="rechazado">Rechazado</option>
                        </select>
                    </div>
                </div>
            </div>

            <div className="tableContainer">
                <div className="tableWrapper">
                    <table className="pagosTable">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Rifa</th>
                                <th>Números</th>
                                <th>Cliente</th>
                                <th>Teléfono</th>
                                <th>Email</th>
                                <th>Método Pago</th>
                                <th>Referencia / ID usuario</th>
                                <th>Estado</th>
                                <th>Fecha</th>
                                <th>Comprobante</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtrados.length === 0 ? (
                                <tr>
                                    <td colSpan="12" style={{ textAlign: 'center', padding: '20px' }}>
                                        {pagos.length === 0 ? 'No hay pagos disponibles' : 'No se encontraron pagos con los filtros aplicados'}
                                    </td>
                                </tr>
                            ) : (
                                filtrados.slice(0, visibleCount).map(pago => (
                                <tr key={pago.idPago}>
                                    <td><strong>#{pago.idPago}</strong></td>
                                    <td>{pago.rifa_nombre || 'N/A'}</td>
                                    <td><code>{pago.numeros}</code></td>
                                    <td>{pago.nombre}</td>
                                    <td>{pago.telefono}</td>
                                    <td>{pago.email}</td>
                                    <td>{getMetodoPagoTexto(pago.metodo_pago)}</td>
                                    <td>{pago.referencia || 'N/A'}</td>
                                    <td>
                                        <span className={`estado${pago.estado.charAt(0).toUpperCase() + pago.estado.slice(1)}`}>
                                            {getEstadoTexto(pago.estado)}
                                        </span>
                                    </td>
                                    <td>{new Date(pago.createdAt).toLocaleDateString()}</td>
                                    <td>
                                        {pago.imagen_comprobante ? (
                                            <img 
                                                src={`data:image/jpeg;base64,${pago.imagen_comprobante}`} 
                                                alt="Comprobante" 
                                                className="comprobanteImg"
                                                onClick={() => handleImageClick(pago.imagen_comprobante)}
                                            />
                                        ) : (
                                            <span style={{ color: '#95a5a6', fontStyle: 'italic' }}>Sin imagen</span>
                                        )}
                                    </td>
                                    <td>
                                        {pago.estado === 'pendiente' && (
                                            <div className="acciones">
                                                <button 
                                                    className="btnAprobar" 
                                                    onClick={() => handleAprobar(pago)}
                                                    title="Aprobar pago"
                                                >
                                                    <FontAwesomeIcon icon={faCheck} />
                                                    Aprobar
                                                </button>
                                                <button 
                                                    className="btnRechazar" 
                                                    onClick={() => handleRechazar(pago)}
                                                    title="Rechazar pago"
                                                >
                                                    <FontAwesomeIcon icon={faTimes} />
                                                    Rechazar
                                                </button>
                                            </div>
                                        )}
                                        {pago.estado !== 'pendiente' && (
                                            <div className="aprobacionInfo">
                                                <div><strong>{pago.aprobado_por}</strong></div>
                                                <div>{pago.fecha_aprobacion ? new Date(pago.fecha_aprobacion).toLocaleDateString() : 'N/A'}</div>
                                            </div>
                                        )}
                                    </td>
                                </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {filtrados.length > visibleCount && (
                <button 
                    className="btnVerMas" 
                    onClick={handleShowMore}
                >
                    Ver más ({filtrados.length - visibleCount} restantes)
                </button>
            )}

            {/* Modal de confirmación */}
            {modalVisible && (
                <div className="modalOverlay">
                    <div className="modalContent">
                        <h3>
                            {accion === 'aprobar' ? 'Aprobar Pago' : 'Rechazar Pago'}
                        </h3>
                        <p>
                            {accion === 'aprobar' 
                                ? `¿Está seguro de que desea aprobar el pago #${pagoSeleccionado?.idPago}?`
                                : `¿Está seguro de que desea rechazar el pago #${pagoSeleccionado?.idPago}?`
                            }
                        </p>
                        
                        {accion === 'rechazar' && (
                            <div className="motivoRechazo">
                                <label>Motivo del rechazo (opcional):</label>
                                <textarea
                                    value={motivoRechazo}
                                    onChange={(e) => setMotivoRechazo(e.target.value)}
                                    placeholder="Ingrese el motivo del rechazo..."
                                    rows="3"
                                />
                            </div>
                        )}

                        <div className="modalActions">
                            <button 
                                className="btnCancelar" 
                                onClick={() => setModalVisible(false)}
                            >
                                Cancelar
                            </button>
                            <button 
                                className={accion === 'aprobar' ? 'btnConfirmarAprobar' : 'btnConfirmarRechazar'}
                                onClick={confirmarAccion}
                            >
                                {accion === 'aprobar' ? 'Aprobar' : 'Rechazar'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

                    {/* Modal de imagen */}
                    {imagenModal.visible && (
                        <div className="imagenModalOverlay" onClick={closeImageModal}>
                            <div className="imagenModalContent" onClick={(e) => e.stopPropagation()}>
                                <button className="imagenModalClose" onClick={closeImageModal}>
                                    <FontAwesomeIcon icon={faTimes} />
                                </button>
                                <img 
                                    src={imagenModal.src} 
                                    alt="Comprobante en grande" 
                                    className="imagenModalImg"
                                />
                            </div>
                        </div>
                    )}

                    <ToastContainer />
                </div>
            );
        }
